// extracted by mini-css-extract-plugin
export default {"RanksHeading":"RanksModal_RanksHeading__wQ-x2","RanksWrapper":"RanksModal_RanksWrapper__fdX1O"};